import React from "react";
import Section from "./Section";

export default function Features() {
  return (
    <Section id="features" className="ud-features">
      <div className="row">
        <div className="col-lg-12">
          <div className="ud-section-title">
            <span>Özellikler</span>
            <h2>Aidat+ İle Yönetim Artık Çok Daha Kolay</h2>
            <p>
              Aidat+, site ve apartman yönetimini tek panelden hızlı, şeffaf ve
              güvenli şekilde yönetmeniz için tasarlandı.
            </p>
          </div>
        </div>
      </div>

      <div className="row">
        {/* Aidat & Ödeme Yönetimi */}
        <div className="col-xl-3 col-lg-3 col-sm-6">
          <div className="ud-single-feature wow fadeInUp" data-wow-delay=".1s">
            <div className="ud-feature-icon">
              <i className="lni lni-credit-cards"></i>
            </div>
            <div className="ud-feature-content">
              <h3 className="ud-feature-title">Aidat & Ödeme Takibi</h3>
              <p className="ud-feature-desc">
                Aidatları tanımlayın, ödemeleri takip edin ve borç durumlarını
                anlık olarak görüntüleyin.
              </p>
            </div>
          </div>
        </div>

        {/* Site & Apartman Yönetimi */}
        <div className="col-xl-3 col-lg-3 col-sm-6">
          <div className="ud-single-feature wow fadeInUp" data-wow-delay=".15s">
            <div className="ud-feature-icon">
              <i className="lni lni-apartment"></i>
            </div>
            <div className="ud-feature-content">
              <h3 className="ud-feature-title">Site & Apartman Yönetimi</h3>
              <p className="ud-feature-desc">
                Sitelerinizi, apartmanlarınızı ve dairelerinizi kolayca yönetin.
              </p>
            </div>
          </div>
        </div>

        {/* Kullanıcı & Rol Yönetimi */}
        <div className="col-xl-3 col-lg-3 col-sm-6">
          <div className="ud-single-feature wow fadeInUp" data-wow-delay=".2s">
            <div className="ud-feature-icon">
              <i className="lni lni-users"></i>
            </div>
            <div className="ud-feature-content">
              <h3 className="ud-feature-title">Kullanıcı & Rol Yönetimi</h3>
              <p className="ud-feature-desc">
                Yönetici, site yöneticisi ve bina yöneticisi rollerini kolayca
                tanımlayın.
              </p>
            </div>
          </div>
        </div>

        {/* Bildirim & Duyurular */}
        <div className="col-xl-3 col-lg-3 col-sm-6">
          <div className="ud-single-feature wow fadeInUp" data-wow-delay=".25s">
            <div className="ud-feature-icon">
              <i className="lni lni-alarm"></i>
            </div>
            <div className="ud-feature-content">
              <h3 className="ud-feature-title">Bildirim & Duyurular</h3>
              <p className="ud-feature-desc">
                Duyurular yayınlayın, önemli bildirimleri tüm kullanıcılara
                anında iletin.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
